import { arrayOf, number, shape, string } from "prop-types"
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts"
import { colors, chartColors } from "components/shared/admin_colors"

const TimeseriesChart = ({ data }) => {
  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid stroke={colors.neutral_060} strokeDasharray="5 5" />
          <XAxis dataKey="date" stroke={colors.neutral_010} padding={{ left: 10 }} />
          <YAxis stroke={colors.neutral_010} padding={{ bottom: 10 }} />
          <Tooltip />
          <Line type="monotone" dataKey="count" stroke={chartColors.blue} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}

TimeseriesChart.propTypes = {
  data: arrayOf(
    shape({
      date: string,
      count: number
    })
  )
}

export default TimeseriesChart
